export default __webpack_public_path__ + "static/media/10.ed58c765.webp";